// extracted by mini-css-extract-plugin
export default {"peopleIcon":"MultipleAccountsFound_peopleIcon__VWM8v"};